<div class="container-fluid">
	<nav id="navbar" class="navbar desktopNav">
		<!-- DESKTOP CONTENT -->
		<div>
			<!-- Zenklub logo. -->
			<a class="navbar-brand"
				><img
					class="logo"
					alt="'SIGN_UP.HEADER.IMG_ALT' | translate"
					src="/assets/images/logo-zenoffice-default.svg"
			/></a>
			<!-- Menu. -->
			<div id="navbar" class="navbar-collapse">
				<div class="main-menu">
					<!-- Main menu. -->
					<ul class="menu list-inline">
						<!--Menu steps-->
						<li class="active">
							<div class="navigation-step">
								<div class="index-sign">1</div>
								<span>{{ 'SIGN_UP.HEADER.WELCOME' | translate }}</span>
							</div>
						</li>

						<li>
							<div class="navigation-step">
								<div class="index-sign">2</div>
								<span>{{ 'SIGN_UP.HEADER.ACCOUNT' | translate }}</span>
							</div>
						</li>

						<li>
							<div class="navigation-step">
								<div class="index-sign">3</div>
								<span>{{ 'SIGN_UP.HEADER.DATA' | translate }}</span>
							</div>
						</li>
						<li>
							<div class="navigation-step">
								<div class="index-sign">4</div>
								<span>{{ 'SIGN_UP.HEADER.PAYMENT' | translate }}</span>
							</div>
						</li>
					</ul>
				</div>
			</div>
		</div>
	</nav>
</div>

<hr />
